import { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { AiOutlineClose, AiOutlineCheck, AiFillClockCircle } from "react-icons/ai";
import { useSelector, useDispatch } from 'react-redux';
import host from "../../host";
import axiosInstance from '../../utils/axiosInstanse';
import { clearNotification } from '../../reduser/notificationSlice';
import { showNotification } from '../../utils/notificationUtils';
import unpaid_date from '../../utils/checkType';
import './archive.css';

export default function Cards(item) {
  const { note } = item;
  const [currentNote, setCurrentNote] = useState(note);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const actionsRef = useRef(null);
  const notification = useSelector(state => state.notification);
  const dispatch = useDispatch();

  // Закрытие дропдауна при клике вне
  useEffect(() => {
    if (!dropdownOpen) return;
    const handleClick = (e) => {
      if (actionsRef.current && !actionsRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [dropdownOpen]);

  const getCardMod = () => {
    if (currentNote.is_denied || currentNote.sap_approved === false) {
      return 'arch-card--rejected';
    } else if (currentNote.is_signed && currentNote.sap_approved) {
      return 'arch-card--approved';
    }
    return 'arch-card--pending';
  };

  useEffect(() => {
    if (notification.show) {
      const now = Date.now();
      const elapsedTime = now - notification.startTime;
      const remainingTime = 4000 - elapsedTime;

      if (remainingTime > 0) {
        const timer = setTimeout(() => {
          dispatch(clearNotification());
        }, remainingTime);
        return () => clearTimeout(timer);
      } else {
        dispatch(clearNotification());
      }
    }
  }, [notification, dispatch]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await axiosInstance.post(`${host}api/delete_note/`, currentNote);
      if (response.status === 200) {
        setCurrentNote(response.data);
        showNotification(dispatch, 'Успешно!', 'success');
      }
    } catch (err) {
      showNotification(dispatch, 'Не удалось отменить', 'error');
    }
  };

  const cardMod = getCardMod();

  const showActions =
    (currentNote.is_signed &&
      !currentNote.delete_approved &&
      !currentNote.delete_mark && currentNote.sap_approved !== false ||
      currentNote.is_new);

  return (
    <motion.div
      initial={{ opacity: 0, y: -16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.12 }}
      style={{ width: '100%' }}
    >
      <div className={`arch-card ${cardMod}`}>
        {/* Header */}
        <div className="arch-card-header">
          <span className="arch-card-tab">Табельный {currentNote.tab_num}</span>
          <span className="arch-card-id">Заявка № {currentNote.id}</span>
          {showActions && (
            <div className="arch-card-actions" ref={actionsRef}>
              <button
                className="arch-dots-btn"
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                ⋮
              </button>
              {dropdownOpen && (
                <div className="arch-dropdown">
                  <button
                    className="arch-dropdown-item"
                    onClick={(e) => {
                      setDropdownOpen(false);
                      handleSubmit(e);
                    }}
                  >
                    Отменить
                  </button>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Body */}
        <div className="arch-card-body">
          {/* Delete marks */}
          {currentNote.delete_mark && (
            <div className="arch-delete-mark">
              Помечена на отмену
            </div>
          )}
          {currentNote.delete_approved && (
            <div className="arch-delete-mark">
              Отменена
            </div>
          )}

          <div className="arch-date">
            Разрешён выход с завода: {currentNote.date}
          </div>

          <div className="arch-time-row">
            <span className="arch-time-item">С {currentNote.time_from}</span>
            <span className="arch-time-item">
              {currentNote.time_until ? `По ${currentNote.time_until}` : 'Без времени'}
            </span>
          </div>

          <div className="arch-reason">
            {currentNote.official ? 'По служебному'
              : currentNote.official_in_plane ? 'Служебная внутри завода'
                : currentNote.unpaid_vacation_time ? unpaid_date(currentNote)
                  : currentNote.personal ? 'По личному'
                    : 'Не определено'}
          </div>

          {note.nvo_text && (
            <div className="arch-nvo">
              {note.nvo_text}
            </div>
          )}

          {currentNote.description && (
            <div className="arch-desc">
              <strong>Описание причины:</strong> {currentNote.description}
            </div>
          )}

          {/* Solution block */}
          <div className="arch-solution">
            <div className="arch-solution-col">
              <div className="arch-solution-heading">Решение</div>
              {currentNote.is_signed ? (
                <div className="arch-solution-item arch-solution-item--success">
                  <AiOutlineCheck /> Одобрено руководителем
                </div>
              ) : (currentNote.is_denied & currentNote.delete_approved) ? (
                <div className="arch-solution-item arch-solution-item--danger">
                  <AiOutlineClose /> Отменено пользователем
                </div>
              ) : currentNote.is_denied ? (
                <div className="arch-solution-item arch-solution-item--danger">
                  <AiOutlineClose /> Отклонено руководителем
                </div>
              ) : (
                <>
                  <div className="arch-solution-item">
                    {currentNote.first_supervisor_answer ? (
                      <><AiOutlineCheck /> Непосредственный руководитель</>
                    ) : currentNote.first_supervisor_answer == null ? (
                      <><AiFillClockCircle /> Непосредственный руководитель</>
                    ) : (
                      <><AiOutlineClose /> Непосредственный руководитель</>
                    )}
                  </div>
                  <div className="arch-solution-item">
                    {currentNote.last_supervisor_answer ? (
                      <><AiOutlineCheck /> Вышестоящий руководитель</>
                    ) : (
                      <><AiFillClockCircle /> Вышестоящий руководитель</>
                    )}
                  </div>
                </>
              )}
            </div>

            {!(currentNote.is_denied || currentNote.delete_approved) ? (
            <div className="arch-solution-col">
              <div className="arch-solution-heading">Система</div>
              {currentNote.sap_approved === null ? (
                <div className="arch-solution-item arch-solution-item--pending">
                  <AiFillClockCircle /> Ожидание
                </div>
              ) : currentNote.sap_approved ? (
                <div className="arch-solution-item arch-solution-item--success">
                  <AiOutlineCheck /> Одобрено системой
                </div>
              ) : (
                <div className="arch-solution-item arch-solution-item--danger">
                  <AiOutlineClose /> Отклонено системой по причине — {currentNote.comment_from_sap}
                </div>
              )}
            </div>
            ) : null}
          </div>
        </div>
      </div>
    </motion.div>
  );
}